import zaun_1 from './zaun_1.jpg';
import zaun_2 from './zaun_2.jpg';
import zaun_3 from './zaun_3.jpg';
import zaun_4 from './zaun_4.jpg';
import zaun_5 from './zaun_5.jpg';
import zaun_6 from './zaun_6.jpg';

export const portfolio_zaune = [
    {product_img: zaun_1},
    {product_img: zaun_2},
    {product_img: zaun_3},
    {product_img: zaun_4},
    {product_img: zaun_5},
    {product_img: zaun_6}
]